import { render, staticRenderFns } from "./TextWysiwyg.vue?vue&type=template&id=48d3f25d"
import script from "./TextWysiwyg.vue?vue&type=script&lang=js"
export * from "./TextWysiwyg.vue?vue&type=script&lang=js"
import style0 from "./TextWysiwyg.vue?vue&type=style&index=0&id=48d3f25d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports